import React from 'react';
import loginLogo from '../../assets/img/PassPlay_Landscape_Transparent.png';
import styles from '../login/login.module.css';
import { Text, Button } from '@nike/eds';
import { useI18nContext } from '../../context/language/use-i18n-context';
import ts from './i18n';
import { useOktaAuth } from '@okta/okta-react';

interface LoginProps {
  isNetworkError?: boolean;
}

export const Login: React.FC<LoginProps> = ({ isNetworkError = false }) => {
  const { i18nString } = useI18nContext();
  const oktaAuthInstance = useOktaAuth();

  const handleLogin = () => {
    oktaAuthInstance.oktaAuth.signInWithRedirect();
  };

  return (
    <>
      {isNetworkError && (
        <h1 className={styles.login_error}>
          <center> THERE HAS BEEN AN ERROR - ENSURE YOU ARE CONNECTED TO NIKE NETWORK </center>
        </h1>
      )}
      <div className="eds-flex eds-flex--justify-content-center eds-flex--align-items-center">
        <img className={styles.login_img} alt="passplay logo" src={loginLogo}></img>
      </div>
      <hr></hr>
      <Text as={'h2'} className={`${styles.login_text} h2_font`}>
        {i18nString(ts.LOG_INTO_PASS_PLAY)}
      </Text>
      <div className={styles.login_div}>
        <Button
          size="medium"
          variant="primary"
          onClick={() => handleLogin()}
          className={styles.login_nike_btn}
        >
          {i18nString(ts.LOGIN_NTLM_BUTTON)}
        </Button>
      </div>
    </>
  );
};
